export class ItalianService {

  //#################################################################################
  //
  // This service holds hashmap containing all german strings used in our platform
  // When translating, please keep keys (first argument) same, while
  // adapting the values (seconds argument).
  //
  //#################################################################################

  private lang = new Array();

  constructor() {
    //define strings for missing or excessive number of arguments
    this.populateMissingOrExcessiveArguments();

    //populate all bracket-related errors
    this.populateBracketErrors("definizione del colore");

    //define static string that do not need to be translated
    this.populateStaticStrings();

    //define strings related to login
    this.defineLoginStrings();

    //define key-value pairs (keys are fixed, please adjust values only on the right)
    this.define("yes", "Sì");
    this.define("no", "No");
    this.define("menu", "Menu");
    this.define("saveFile", "Salva programma");
    this.define("loadFile", "Carica programma");
    this.define("saveCanvas", "Salve immagine");
    this.define("fullscreen", "Attiva/disattiva modalità a schermo intero");
    this.define("newfeatures", "Cosa c'è di nuovo?");
    this.define("Cheatsheet", "Appunti");
    this.define("background", "Salvaschermi");

    //language-related strings
    this.define("language", "Scegli una lingua");

    //User Interface: history, input and general UI
    this.define("previousCommands", "Comandi precedente:");
    this.define("input", "INPUT: ");
    this.define("definitionInInput", "Invoca comandi dall'editor senza TO e END");
    this.define("timeout", "L'esecuzione richiede più tempo del previsto - Continuare?");
    this.define("errorineditor", "Correggi tutti gli errori dell'editor per continuare");
    this.define("enterCommand", "Inserisci i comandi qui");
    this.define("errorInInput", "Comando non capito. C'è un errore?");
    this.define("stopExecution", "Vuoi interrompere l'esecuzione in corso?")
    this.define("cmdAlreadyFinished", "L'esecuzione è già terminata!");
    this.define("hoppla", "Oops...");
    this.define("cancel", "interrompi");
    this.define("continue", "continua");

    //boolean values
    this.define("true", "vero");
    this.define("false", "falso");

    //status update while execution
    this.define("parsingEditor", "Lettura del comando in corso...");
    this.define("executingVisitor", "Esecuzione del comando in corso...");
    this.define("stoppingVisitor", "Interruzione del comando in corso...");
    this.define("init", "Inizializzazione")
    this.define("checking", "Controllo dell'editor in corso...");

    //syntax checking: program declaration
    this.define("missingTo", "Manca un 'to'");
    this.define("missingEnd", "Manca un 'end'");
    this.define("manyTos", "Troppi 'to'");
    this.define("manyEnds", "Troppi 'end'");
    this.define("maybeTo", "'to' è scritto in modo sbagliato");
    this.define("misspelledEnd", "'end' è scritto in modo sbagliato");
    this.define("noName", "Manca il nome del programma");
    this.define("noToNoName", "Mancano 'to' e il nome del programma");
    this.define("nameTO", "Non puoi chiamare il programma 'to'");
    this.define("nameEND", "Non puoi chiamare il programma 'end'");
    this.define("nameCMD", "Questo nome esiste già in Logo");
    this.define("nameFUNC", "Questa funzione esiste già in Logo");
    this.define("nosuchmethod", "Non esiste un programma con questo nome");
    this.define("noEOL", "Inizia dalla prossima riga");
    this.define("noEOLbeforeEND", "'end' non può essere sulla stessa riga di un altro comando");
    this.define("eolAfterTo", "'to' e il nome del programma devono essere sulla stessa riga");
    this.define("methodNameWhitespace", "Il nome del programma non può contenere spazi");

    //syntax checking: parameters
    this.define("paramsNoColon", "Manca un ':' prima del nome del parametro?");
    this.define("doubleDeclaration", "Un programma con lo stesso nome è già definito");
    this.define("eolBeforeParams", "Il nome del programma e i parametri devono essere sulla stessa riga");
    this.define("paramsOneLine", "Tutti i parametri devono essere sulla stessa riga");
    this.define("sameParam", "Hai ripetuto il nome dei seguenti parametri: ");
    this.define("paramDeclsNotOk", "Spazi dopo il ':' non sono permessi");
    this.define("paramDeclNoName", "Manca un nome di parametro dopo il ':'");

    //syntax checking: colors
    this.define("rgbMissingValues", "Servono 3 valori per definire un colore");
    this.define("rgbCommas", "Virgole non sono permesse nella definizione di un colore");
    this.define("colornameMisspelled", "Il nome del colore è scritto in modo sbagliato. ");
    this.define("noColorWithThisName", "Questo colore non è conosciuto: ");

    //syntax checking: blocks and brackets
    this.define("bracketError", "Problemi con le parentesi");
    this.define("squareBracketProblem", "Problemi con le parentesi quadre []");
    this.define("roundBracketProblem", "Problemi con le parentesi rotonde ()");

    //syntax checking: while
    this.define("whileMissingBlock", "Cosa dovrebbe essere ripetuto nel 'while'?");
    this.define("whileManyBlocks", "Troppi blocchi [] dopo il 'while'");
    this.define("whileNoArgs", "Mancano due parametri dopo il 'while'");

    //syntax checking: repeat
    this.define("repeatMissingExpr", "Manca un numero dopo 'repeat'");
    this.define("repeatMissingBlock", "Cosa vuoi ripetere nel 'repeat'?");
    this.define("repeatNoArg", "Al 'repeat' manca un numero e un blocco []");
    this.define("repeatNoBrackets", "Mancano le parentesi quadre [] attorno al comando che vuoi ripetere");
    this.define("repeatManyBlocks", "Troppi blocchi [] dopo il 'repeat', inserisci tutti i comandi in un blocco solo");

    //syntax checking: if-else
    this.define("ifNoBlock", "Cosa vuoi eseguire nel 'if'?");
    this.define("ifManyBlocks", "Troppi blocchi [] dopo 'if'");
    this.define("ifBrackets", "Non servono parentesi attorno alla condizione del 'if'");
    this.define("ifNoArgs", "Manca qualcosa dopo 'if'");

    //syntax checking: make
    this.define("makeNoVal", "Manca il secondo parametro di 'make'");
    this.define("makeNoLit", "Manca il simbolo \" e il nome di una variabile come primo parametro di 'make'");
    this.define("makeNoArgs", "Mancano entrambi i parametri di 'make'");
    this.define("derefMake", "Usa ':' invece di \" prima del nome del parametro");
    this.define("makeReverse", "Inverti l'ordine dei parametri di 'make'");
    this.define("makeColon", "Usa \" invece di ':' prima del nome della variabile in 'make'");
    this.define("variableNotDeclared", "Questa variabile non è definita: ");
    this.define("makeLitNotOk", "Non sono permessi spazi dopo \"");
    this.define("derefNotOk", "Rimuovi gli spazi dopo ':'");

    //syntax checking: general error messages
    this.define("extraneousInput", "C'è un errore in questo programma");
    this.define("noViableAlternative", "Hai dimenticato qualcosa qui?");
    this.define("didYouMean", "Intendevi: ");
    this.define("tooSmall", "Il numero è troppo piccolo");
    this.define("specialCharacters", "Questo carattere non è permesso: ");
    this.define("whitespace", "Manca uno spazio tra comandi adiacenti");
    this.define("justExpression", "Manca un comando prima del valore");
    this.define("tokenRecognition", "Non capisco: ");
    this.define("tooMuch", "Troppi: ");
    this.define("funcMisspelled", " non è conosciuto");

    // Tooltips in header
    this.define("tooltipButtonStop", "Interrompi il programma in corso.");
    this.define("tooltipButtonDebug", "Esegui il tuo programma passo per passo.");
    this.define("tooltipButtonForward", "Vai un passo indietro.");
    this.define("tooltipButtonBackward", "Vai un passo in avanti.");
    this.define("tooltipButtonSpeed", "Adatta la velocità d'esecuzione");
    this.define("tooltipButtonLanguage", "Cambia le impostazioni della lingua");
    this.define("tooltipButtonTurtle", "Cambia l'icona della tartaruga");

    // Debug control buttons
    this.define("buttonDebugToggle", "Passo per passo");
    this.define("buttonForward", "Avanti");
    this.define("buttonBackward", "Indietro");

    // Debug watch labels
    this.define("watchPenDown", "Penna giù:");
    this.define("watchErasing", "Cancellare:");
    this.define("watchVisible", "Visibile:");
    this.define("watchColor", "Colore della penna:");
    this.define("watchWidth", "Spessore della penna:");
    this.define("watchDirection", "Direzione:");

    // Run time error exceptions
    this.define("exception_division_by_zero", "Non è possibile dividere per 0");
    this.define("exception_invalid_argument_asin", "Il valore per arcsin deve essere compreso tra -1 e 1");
    this.define("exception_invalid_argument_acos", "Il valore per arccos deve essere compreso tra -1 e 1");
    this.define("exception_invalid_argument_tan", "Il valore non può essere della forma (0.5 + k) * PI");
    this.define("exception_invalid_argument_mod", "Calcolare 'n mod 0' non è possibile");
    this.define("exception_invalid_argument_colornumber", "Il colore specificato dal numero non esiste: ");
    this.define("exception_invalid_argument_colorname", "Il colore con il nome specificato non esiste: ");
    this.define("exception_invalid_argument_rgb", "Il colore specificato non è valido: ");
    this.define("exception_sqrt_negative_number", "Non è possibile calcolare la radice di numeri negativi");
    this.define("exception_log10_negative_number", "Non è possibile calcolare il logaritmo di numeri negativi");

    // Catching invalid arguments that might lead to unexpected behavior
    this.define("exception_setpw_negative_number", "Lo spessore della penna non può essere negativo");
    this.define("exception_wait_negative_number", "Non è possibile aspettare una quantità di tempo negativa");
    this.define("exception_circle_negative_number", "Non è possibile disegnare un cerchio con raggio negativo");

    //quickstart: general text
    this.define("tutorialtype", "Scegli un tutorial.");
    this.define("doyouneedhelp", "Hai bisogno di aiuto?");
    this.define("firststeps", "Primi passi");
    this.define("definenewcommands", "Definire nuovi comandi");
    this.define("debugger", "Esecuzione passo per passo");

    //quickstart: getting started
    this.define("intro1", "In questo tutorial imparerai come programmare in XLogoOnline.");
    this.define("intro2", "Vedi che bel disegno? Presto saprai come creare disegni come questo da solo.");
    this.define("intro3", "I programmi sono composti da comandi. Per esempio, FD e BK (usati per tracciare linee), così come RT e LT (gira a destra o sinistra) sono dei comandi.");
    this.define("intro4", "Facciamo un tentativo! Clicca all'interno dell'area e schiaccia Invio");
    this.define("intro5", "La tartaruga ha eseguito il programma e il risultato è mostrato qui");
    this.define("intro6", "Per favore cancella il disegno usando il comando CS.");
    this.define("intro7", "CS cancella tutte le linee e rimette la tartaruga al centro");
    this.define("intro8", "I programmi possono anche contenere più comandi. Sai cosa fa questo programma?");
	  this.define("intro9", "Tutti i programmi precedentemente eseguiti sono elencati qui.");
    this.define("intro10", "Usando le freccette " + String.fromCharCode(8679) + " e " + String.fromCharCode(8681) + ", puoi recuperare vecchi programmi senza dover digitare tutto da capo.");
    this.define("intro11", "Cosa pensi che accade se c'è un errore?");
    this.define("intro12", "Questo programma contiene un errore. Riesci a trovarlo? Scopri come la tartaruga si comporta quando c'è un errore.");
    this.define("intro13", "La tartaruga non capisce il nostro programma e, invece, è apparso un messaggio d'errore in arancione.");
    this.define("intro14", "Fine! Adesso divertiti a scrivere il tuo primo programma!");

    //quickstart: how to use the editor
    this.define("editor1", "In questo tutorial imparerai come definire e usare i tuoi comandi.");
    this.define("editor2", "Vedi questo programma? Cosa pensi che farà?");
    this.define("editor3", "Cosa?! Un programma così complicato, solo per disegnare quattro quadrati...");
    this.define("editor4", "Non esiste una soluzione più bella? Come questa magari?");
    this.define("editor5", "Purtroppo no; la tartaruga non conosce il comando QUADRAT... Quindi definiamolo noi!");
    this.define("editor6", "Nuovi comandi sono definiti qui. Questo campo è chiamato editor.");
    this.define("editor7", "\'TO\' QUADRAT \'END\' definisce un nuovo comando chiamato QUADRAT.");
    this.define("editor8", "La stessa finestra dell'editor può essere usata per definire più comandi.");
    this.define("editor9", "Oops! Vedi la crocetta rossa sulla riga 5? La crocetta indica che c'è un errore su questa riga. Sai cosa potrebbe essere? Abbiamo definito il comando QUADRAT due volte. (Suggerimento: Dopo aver finito questo tutorial, puoi passare con il mouse sopra la crocetta e scoprire ulteriori dettagli sull'errore)");
    this.define("editor10", "Che effetto deve avere il comando QUADRAT? Definiamo il comportamento desiderato tra TO e END");
    this.define("editor11", "Guardiamo cosa fa. Cosa ti aspetti? Prova a vedere cosa succede!");
    this.define("editor12", "È un quadrato, con un solo comando! Comodo! Così possiamo disegnare figure complesse molto facilmente.");
    this.define("editor13", "Complimenti! Hai definito il tuo primo comando (nell'editor) e lo hai invocato. Buon divertimento nella programmazione!");
  
    //login service
    this.define("loginButton", "Login");
    this.define("logoutButton", "Logout");
    this.define("registerButton", "Registrare")
    this.define("loginTitle", "Login");
    this.define("username", "Nome utente");
    this.define("password", "password (opzionale)");
    this.define("successfulLoginTitle", "Login effettuato");
    this.define("successfulLoginText", "Sei connesso come l'utente ");
    this.define("failLoginTitle", "Login errato");
    this.define("tryAgain", "Riprova!")
    this.define("registerTitle", "Registra come nuovo utente");
    this.define("repeatPassword", "ripeti la password");
    this.define("passwordMisatchTitle", "Le password non corrispondono");
    this.define("passwordMisatchText", "Le password non corrispondono. Riprova ancora!");
    this.define("successfulRegistrationTitle", "Registrazione riuscita");
    this.define("successfulRegistrationText", "La registrazione è riuscita, sei connesso come ");
    this.define("serversuccess", "Successo");
    this.define("unknownuser", "Il nome utente non è esistente");
    this.define("wrongpassword", "password errata per questo nome utente");
    this.define("usernamealreadytaken", "Nome utente è già esistente. Per favore, scegliere un'altro nome utente.")
    this.define("toomuchtext", "Questo documento è troppo grande");
    this.define("toomuchtexthint", "Dividi la tua soluzione in parti piu` corte");
    this.define("Ihaveread", "Ho letto e accetto ");
    this.define("datenschutz", "le condizioni sulla privacy");
    this.define("readandaccepted", "");
    this.define("documentexists", "Il documento è già esistente");
    this.define("overwrite", "Desideri sovrascrivere il documento?");
    this.define("writtensuccessfully", "Il documento è stato salvato");
  } 

  private defineMissingOrIncorrectBrackets(type1, type2, type3, type4, type5, type6, commandname) {
    if (commandname === "NONE") {
      this.define(type1, "Manca la parentesi destra ']'");
      this.define(type2, "Manca la parentesi sinistra '['");
      this.define(type3, "Mancano le parentesi '[]'");
      this.define(type4, "Parentesi destra scorretta, usa ']'");
      this.define(type5, "Parentesi sinistra scorretta, usa '['");
      this.define(type6, "Parentesi sbagliate, usa '[]'");
    } else {
		this.define(type1, "Parentesi destra ']' mancante a '" + commandname + "'");
		this.define(type2, "Parentesi sinistra '[' mancante a '" + commandname + "'");
		this.define(type3, "Parentesi '[]' mancanti a '" + commandname + "'");
		this.define(type4, "Parentesi destra scorretta, usa ']' a '" + commandname + "'");
		this.define(type5, "Parentesi sinistra scorretta, usa '[' a '" + commandname + "'");
		this.define(type6, "Parentesi scorrette, usa '[]' a '" + commandname + "'");
    }
  }

    /*//------------------------------------
    // Strings related to LOGIN TODOOOOOO
    *///------------------------------------

    private defineLoginStrings() {
      this.define("notingtosave", "Non c'e' niente da salvare.");
      this.define("howtosave", "Come  preferisci salvare?");
      this.define("save", "Salvare");
      this.define("locally", "Sul mio computer");
      this.define("online", "Online");
      this.define("load", "Caricare programmi");
      this.define("noconnection", "Connessione fallita");
      this.define("yourcode", "Il tuo codice di accesso personale. Annotalo per accedere ai tuoi programmi da qualsiasi luogo.");
      this.define("filename", "Nome del mio file");
      this.define("login", "Login");
      this.define("chapterx", "Capitolo X Esercizio Y");
      this.define("loadprogram", "Carica programma:");
      this.define("chooseprogram", "Scegli un programma");
      this.define("incorrectpassword", "Codice d'accesso errato");
      this.define("loginsuccess", "Login effettuato con successo");
      this.define("youcanloadandstore", "Ora sei in grado di salvare e ricaricare i tuoi programmi online");
      this.define("code", "codice di accesso");
      this.define("iamnew", "Sono nuovo......");
      this.define("logoutsuccess", "Ti sei disconnesso");
  }
  
  //string for "there are too many arguments after command xy"
  tooManyValuesAfter(keyword, command) {
    if (command === "NONE") {
      this.define(keyword, "Troppi valori dopo: ");
    } else {
      this.define(keyword, "Troppi valori dopo '" + command + "'");
    }
  }

  //string for "there are too few arguments after command xy"
  tooFewValuesAfter(keyword, command) {
    if (command === "NONE") {
      this.define(keyword, "Mancano valori dopo: ");
    } else {
      this.define(keyword, "Mancano valori dopo '" + command + "'");
    }
  }

  /*//-----------------------------------------------------------------------------------------------
  // IMPORTNAT: FROM HERE ON ALL STRINGS ARE STATIC. NO TRANSLATION REQUIRED.
  *///-----------------------------------------------------------------------------------------------

  //populate all bracket-related errors (missing, wrong, left, right or both) in general, colors, print, strings, while
  private populateBracketErrors(stringForColorDefintion) {
    this.defineMissingOrIncorrectBrackets("rgbMissingRightBr", "rgbMissingLeftBr", "rgbMissingBothBr", "rgbWrongRightBr", "rgbWrongLeftBr", "rgbWrongParentheses", stringForColorDefintion);
    this.defineMissingOrIncorrectBrackets("blockMissingRightBr", "blockMissingLeftBr", "blockMissingBothBr", "blockWrongRightBr", "blockWrongLeftBr", "blockWrongBrackets", "NONE");
    this.defineMissingOrIncorrectBrackets("printMissingRightParen", "printMissingLeftParen", "printMissingBothParen", "printWrongRightParen", "printWrongLeftParen", "printWrongParen", "print");
    this.defineMissingOrIncorrectBrackets("quotedstringMissingRightBr", "quotedstringMissingLeftBr", "quotedstringMissingBothBr", "quotedstringWrongRightBr", "quotedstringWrongLeftBr", "quotedstringWrongBrackets", "NONE");
    this.defineMissingOrIncorrectBrackets("whileMissingRightParen", "whileMissingLeftParen", "whileMissingBothParen", "whileWrongRightParen", "whileWrongLeftParen", "whileWrongParen", "print");
  }

  populateMissingOrExcessiveArguments() {
    //too few or too many arguments after built-in commands
    this.tooManyValuesAfter("fdManyArgs", "fd");
    this.tooFewValuesAfter("fdNoArgs", "fd");
    this.tooManyValuesAfter("bkManyArgs", "bk");
    this.tooFewValuesAfter("bkNoArgs", "bk");
    this.tooManyValuesAfter("rtManyArgs", "rt");
    this.tooFewValuesAfter("rtNoArgs", "rt");
    this.tooManyValuesAfter("ltManyArgs", "lt");
    this.tooFewValuesAfter("ltNoArgs", "lt");
    this.tooManyValuesAfter("csManyArgs", "cs");
    this.tooManyValuesAfter("ctManyArgs", "ct");
    this.tooManyValuesAfter("puManyArgs", "pu");
    this.tooManyValuesAfter("pdManyArgs", "pd");
    this.tooManyValuesAfter("peManyArgs", "pe");
    this.tooManyValuesAfter("pptManyArgs", "ppt");
    this.tooManyValuesAfter("htManyArgs", "ht");
    this.tooManyValuesAfter("stManyArgs", "st");
    this.tooManyValuesAfter("setscManyArgs", "setsc");
    this.tooFewValuesAfter("setscNoArg", "setsc");
    this.tooManyValuesAfter("setxManyArgs", "setx");
    this.tooFewValuesAfter("setxNoArg", "setx");
    this.tooManyValuesAfter("setyManyArgs", "sety");
    this.tooFewValuesAfter("setyNoArg", "sety");
    this.tooManyValuesAfter("randomManyArgs", "random");
    this.tooFewValuesAfter("randomNoArg", "random");
    this.tooManyValuesAfter("sinManyArgs", "sin");
    this.tooFewValuesAfter("sinNoArg", "sin");
    this.tooManyValuesAfter("cosManyArgs", "cos");
    this.tooFewValuesAfter("cosNoArg", "cos");
    this.tooManyValuesAfter("tanManyArgs", "tan");
    this.tooFewValuesAfter("tanNoArg", "tan");
    this.tooManyValuesAfter("arcsinManyArgs", "arcsin");
    this.tooFewValuesAfter("arcsinNoArg", "arcsin");
    this.tooManyValuesAfter("arccosManyArgs", "arccos");
    this.tooFewValuesAfter("arccosNoArg", "arccos");
    this.tooManyValuesAfter("arctanManyArgs", "arctan");
    this.tooFewValuesAfter("arctanNoArg", "arctan");
    this.tooManyValuesAfter("absManyArgs", "abs");
    this.tooFewValuesAfter("absNoArg", "abs");
    this.tooManyValuesAfter("sqrtManyArgs", "sqrt");
    this.tooFewValuesAfter("sqrtNoArg", "sqrt");
    this.tooManyValuesAfter("logManyArgs", "log");
    this.tooFewValuesAfter("logNoArg", "log");
    this.tooManyValuesAfter("waitManyArgs", "wait");
    this.tooFewValuesAfter("waitNoArg", "wait");
    this.tooManyValuesAfter("circleManyArgs", "circle");
    this.tooFewValuesAfter("circleNoArg", "circle");
    this.tooManyValuesAfter("setheadingManyArgs", "setheading");
    this.tooFewValuesAfter("setheadingNoArg", "setheading");
    this.tooManyValuesAfter("setpcManyArgs", "setpc");
    this.tooManyValuesAfter("setpwManyArgs", "setpw");
    this.tooFewValuesAfter("setpwNoArg", "setpw");
    this.tooManyValuesAfter("printManyArgs", "print");
    this.tooFewValuesAfter("printNoArg", "print");
    this.tooManyValuesAfter("makeManyVals", "make");
    this.tooManyValuesAfter("homeManyArgs", "home");
    this.tooManyValuesAfter("stopManyArgs", "stop");
    this.tooManyValuesAfter("setxyManyArgs", "setxy");
    this.tooManyValuesAfter("powerManyArgs", "power");
    this.tooManyValuesAfter("washManyArgs", "wash");
    this.tooManyValuesAfter("modManyArgs", "mod");

    //too few or too many arguments after user-defined commands
    this.tooManyValuesAfter("procCallTooManyArgs", "NONE");
    this.tooFewValuesAfter("procCallNotEnoughArgs", "NONE");
  }

  populateStaticStrings() {
    //these strings are static and do not need to be translated ever
    this.define("XLogoOnline", "XLogoOnline");
    this.define("XLogoOnlineColor", "#39456B");
  }

  //populate hashmap with key-value pairs for the given language. Keys will be same in all languages
  define(key: string, value: string) {
    this.lang[key] = value;
  }

  getLang() {
    return this.lang;
  }

}



// WEBPACK FOOTER //
// ./src/app/languages/italian.service.ts